import styled from '@emotion/styled';
import type { StylesConfig } from 'src/components/DropdownWrapper/DropdownWrapper';
import { dropdownWrapper, addButton } from 'src/assets/colors';

export const ActionDropdownWrapper = styled('div', { label: 'ActionDropdownWrapper' })`
    position: relative;
`;

export const ActionDropdownContainer = styled('div', { label: 'ActionDropdownContainer' })`
    position: relative;
    width: 100%;
`;

export const CustomOptionWrapper = styled('div', { label: 'CustomOptionWrapper' })<{ isSelected: boolean; isFocused: boolean }>`
    background-color: ${({ isSelected, isFocused }): string =>
        isSelected
            ? dropdownWrapper.option.bgColorSelected
            : isFocused
              ? dropdownWrapper.option.bgColorFocused
              : dropdownWrapper.option.bgColor};
    color: ${({ isSelected, isFocused }): string =>
        isSelected || isFocused ? dropdownWrapper.option.txtColorSelected : dropdownWrapper.option.txtColor};
    cursor: pointer;
    display: block;
    min-height: 26px;
    padding: 3px 1px 3px 10px;
    border-bottom: 1px solid ${dropdownWrapper.option.borderColor};
    position: relative;

    &:hover {
        background-color: ${({ isSelected }): string =>
            isSelected ? dropdownWrapper.option.bgColorSelected : dropdownWrapper.option.bgColorHover};
    }

    &:last-child {
        border-bottom: none;
    }
`;

export const EditLink = styled('a', { label: 'EditLink' })`
    position: absolute;
    display: inline-block;
    right: 1px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    padding: 0;
    width: 24px;
    line-height: 3;
    font-size: 8px;
    font-weight: bold;
    text-align: center;
    text-decoration: none;
    color: ${dropdownWrapper.control.txtColor};
    background: ${dropdownWrapper.control.borderColor};

    &:hover {
        color: ${dropdownWrapper.control.bgColor};
        background: ${dropdownWrapper.indicator.bgColor};
    }
`;

export const OptionContainer = styled('div', { label: 'OptionContainer' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    position: relative;
    font-weight: 400;
    cursor: pointer;
    vertical-align: middle;
`;

export const OptionLabel = styled('span', { label: 'OptionLabel' })<{ isShorten: boolean }>`
    width: ${({ isShorten }): string => (isShorten ? 'calc(100% - 24px)' : '100%')};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const AddButton = styled('a', { label: 'AddButton' })`
    position: absolute;
    right: 10px;
    top: 50%;
    font-size: 11px;
    line-height: 1.45;
    z-index: 2;
    color: ${dropdownWrapper.control.bgColor};
    background: ${addButton.bgColor};
    text-decoration: none;
    padding: 3px 5px;
    transform: translateY(-50%);
    text-transform: uppercase;

    &:hover {
        color: ${dropdownWrapper.control.bgColor};
        background: ${addButton.bgColorIcon};
    }
`;

export const ActionMenuOuterWrapper = styled('div', { label: 'ActionMenuOuterWrapper' })`
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: ${dropdownWrapper.menu.bgColor};
    border: 1px solid ${dropdownWrapper.menu.borderColor};
    border-top-color: ${dropdownWrapper.control.borderColorLight};
    box-shadow: 0 1px 0 ${dropdownWrapper.menu.shadowColor};
    box-sizing: border-box;
    margin-top: -1px;
    max-height: 600px;
    position: absolute;
    left: 0;
    top: 100%;
    width: 100%;
    z-index: 1;
    -webkit-overflow-scrolling: touch;
`;

export const ActionMenuListWrapper = styled('div', { label: 'ActionMenuListWrapper' })`
    max-height: 560px;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
    scrollbar-color: ${dropdownWrapper.scrollbar.thumbColor} ${dropdownWrapper.scrollbar.trackColor};
    scrollbar-gutter: stable;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: ${dropdownWrapper.scrollbar.trackColor};
    }

    &::-webkit-scrollbar-thumb {
        background-color: ${dropdownWrapper.scrollbar.thumbColor};
        border-radius: 4px;
    }
`;

export const getActionDropdownStyles = <T, IsMulti extends boolean>(): StylesConfig<T, IsMulti> => ({
    input: (base) => ({
        ...base,
        position: 'absolute',
        top: '4px',
        left: '10px',
    }),
    menuList: (base) => ({
        ...base,
        maxHeight: '560px',
    }),
    singleValue: (base) => ({
        ...base,
        maxWidth: 'calc(100% - 50px)',
    }),
    clearIndicator: (base) => ({
        ...base,
        zIndex: 1,
        position: 'absolute',
        right: '6px',
        display: 'flex',
        cursor: 'pointer',
        color: dropdownWrapper.indicator.bgColor,
        ':hover': {
            color: dropdownWrapper.deleteButton.bgColorHover,
        },
    }),
});
